// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import isApiError from "@insite/client-framework/Common/isApiError";
import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { getcustomerpartnumbers } from "@vanmeter/App/Services/CustomerPartNumbersService";

type HandlerType = ApiHandler<HasOnSuccess<any> & HasOnError<string> & any, any>;

export const PopulateApiParameter: HandlerType = props => {
    const { onSuccess, onError, ...apiParameter } = props.parameter;
    props.apiParameter = apiParameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getcustomerpartnumbers(props.apiParameter.productIds);
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
        }
        throw error;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.(props.apiResult);

        const productIds = Array.isArray(props.apiParameter.productIds)
            ? props.apiParameter.productIds
            : [props.apiParameter.productIds];

        const cpnData = Object.fromEntries(
            productIds.filter(Boolean).map((productId: string) => {
                const value = props.apiResult[productId];
                const cpn = value
                    ? [value.billToCustomerPartNumbers, value.shipToCustomerPartNumbers].filter(Boolean).join(",")
                    : "";
                return [productId, cpn];
            }),
        );
        props.dispatch({ type: "xPartNumbers/ComplateLoadCpns", data: cpnData });
    }
};

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback];

const loadCustomerPartNumbers = createHandlerChainRunner(chain, "loadCustomerPartNumbers");
export default loadCustomerPartNumbers;
